export default "__VITE_ASSET__CaRKVZwj__"